import React from "react";
import Base from "../core/Base";
import { Link } from "react-router-dom";
import HeaderTitle from "../components/HeaderTitle";

const Policy = () => {
  return (
    <Base>
      <HeaderTitle title="Privacy Policy" />
      <section className="contact-area ptb-100">
        <div className="container mt-5">
          <div className="card terms_cards">
            <div className="card-body">
              <h5 className="text-center  card-header terms_heading">
                Privacy Policy
              </h5>
              <p className="card-text mt-5">
                A privacy policy communicates the library's commitment to
                protecting users' personally identifiable information. A
                well-defined privacy policy tells library users how their
                information is employed and explains the circumstances under
                which personally identifiable information could be disclosed. A
                WELL-DEFINED PRIVACY policy communicates the library's
                commitment to protecting users' personally identifiable
                information, tells library users how their information is
                employed , and explains under what circumstances personally
                identifiable information might be disclosed to third parties.
              </p>
              <p className="card-text">
                Libraries Privacy Policy explains your privacy and
                confidentiality rights, the steps the Libraries fancy respect
                and protect your privacy once you use library resources, and the
                way we affect personally identifiable information that we may
                collect from you.
              </p>
              <p className="card-text">
                Only authorized library staff with assigned, confidential
                passwords shall have access to non-public data stored within the
                Library computing system for the only purpose of performing
                library work. Except when required by law or to satisfy a
                private user's service request, the Library won't disclose any
                personal data collected from patrons. The Library doesn't sell
                or lease patrons' personal information to a person or entity.
              </p>
            </div>
          </div>
        </div>
      </section>
    </Base>
  );
};

export default Policy;
